import React from "react";

const Bash_Exercises = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Exercises</h2>
      <ol><li>Write a script that backs up a directory to /tmp with a timestamp.</li><li>Use <code>grep</code> and <code>awk</code> to extract the 3rd column of a CSV with header removed.</li><li>Write a script that monitors disk usage and emails when > 80%.</li></ol>
    </div>
  );
};

export default Bash_Exercises;
